import(/* webpackMode: "eager" */ "/home/runner/work/spcoin-nextjs-front-end/spcoin-nextjs-front-end/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/spcoin-nextjs-front-end/spcoin-nextjs-front-end/components/utility/ServiceWorkerRegistration.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/spcoin-nextjs-front-end/spcoin-nextjs-front-end/public/assets/miscellaneous/meritWalletLogin.webp");
